    <form nz-form se-container="1">
        <se-title>More Filter</se-title>

        <se
          [acl]="{ ability: ['m1.8'], mode: 'allOf' }" 
          label="Stock & Service">
            <app-stock-item-range
            [(from)]="data.stockCodeFrom" 
            [(to)]="data.stockCodeTo">
            </app-stock-item-range>

        </se>   

        <se 
          label="Stock Location"
          [acl]="{ ability: ['m1.8','m1.64'], mode: 'allOf' }">
            <app-stock-location-range 
            [(from)]="data.locationFrom" 
            [(to)]="data.locationTo">
            </app-stock-location-range>
        </se>   
        
        <se 
          label="Stock Category"
          [acl]="{ ability: ['m1.1','m1.8'], mode: 'allOf' }">
            <app-stock-cate-range
            [(from)]="data.stockCategoryFrom" 
            [(to)]="data.stockCategoryTo">
            </app-stock-cate-range>
        </se>
        
        <se 
          label="Stock Group"
          [acl]="{ ability: ['m1.1','m1.8'], mode: 'allOf' }">
            <app-stock-group-range
            [(from)]="data.stockGroupFrom" 
            [(to)]="data.stockGroupTo">
            </app-stock-group-range>
        </se>
        
        <se 
          label="Stock Class"
          [acl]="{ ability: ['m1.1','m1.8'], mode: 'allOf' }">
            <app-stock-class-range
            [(from)]="data.stockClassFrom" 
            [(to)]="data.stockClassTo">
            </app-stock-class-range>
        </se>

    </form>



    

